/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import Height from "components/height/height";
import { Card, Checkbox, FormControl, Grid, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { fetchLoadPlanVehiclesByID } from "utils/api";
import { useDispatch } from "react-redux";
import { fetchWarehouseByID } from "utils/api";
import { showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { validateField } from "utils/generic";
import { loadVehicleCategoryData } from "utils/api";
import { addloadVehicleCategoryData } from "utils/api";
import { loadPlanVehiclesUpdateData } from "utils/api";

const { default: DashboardLayout } = require("examples/LayoutContainers/DashboardLayout");

const errMsg = {
  color: `red`,
  fontSize: `11px`,
};
let LOGIN_DETAILS;
let EMPLOYEE_DETAILS;
let routePath = "/loadVehicles";

function AddUser() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const dispatch = useDispatch()
  const [screenName, setScreenName] = useState("Add Load Plan Vehicle");
  const [wareHouseName, setwarehouseName] = useState([])
  const [vehicleIDErr, setvehicleIDErr] = useState();
  const [vehicleStatusErr, setvehicleStatusErr] = useState();
  const [selectedNames, setSelectedNames] = useState([]);
  const [dropWareHouseIDErr, setdropWareHouseIDErr] = useState();
  const [LoadVehilcles, setLoadVehilcles] = useState([]);
  const [values, setValues] = React.useState({
    shippingType: "",
    dropLocation: "",
    maximumVolume: "",
    maximumWeight: "",
    registrationNumber: "",
    vehicleType: "",
    vehicleID: "",
    vehicleStatus: "New",
    vehicleCategory: "",
    dropWarehouseID: "",
  });

  LOGIN_DETAILS = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
  values.businessUserID = LOGIN_DETAILS.businessUserID
  EMPLOYEE_DETAILS = JSON.parse(sessionStorage.getItem('Employee_Details'));
  values.warehouseID = EMPLOYEE_DETAILS.employeeWarehouseLocation;



  const handleChange = (name) => (event) => {
    let { value } = event.target;
    if (name === "vehicleID") {
      const selectedVehicle = LoadVehilcles.find(
        (item) => item._id === event.target.value
      );
      setValues({
        ...values,
        vehicleCategory: selectedVehicle.vehicleCategory,
        registrationNumber: selectedVehicle.registrationNumber,
        vehicleType: selectedVehicle.vehicleType,
        vehicleID: event.target.value,
      });
    }
    else if (name === "dropLocation") {
      setValues((preValues) => ({
        ...preValues,
        dropLocation: event.target.value,
        dropWarehouseID: null

      }))
    }
    else if (name === "dropWarehouseID") {
      setValues((preValues) => ({
        ...preValues,
        dropLocation: '',
        dropWarehouseID: event.target.value

      }))
    }
    else if (name === "maximumVolume") {
      value = value.replace(/\D/g, '');
      setValues({ ...values, [name]: value });
    } else if (name === "maximumWeight") {
      value = value.replace(/\D/g, '');
      setValues({ ...values, [name]: value });
    }
    else {
      setValues({ ...values, [name]: event.target.value });
    }
  };

  useEffect(() => {
    id === undefined ? setScreenName("Add New Load Plan Vehicle") : setScreenName("Edit Load Plan Vehicle");
    (async () => {
      if (id !== undefined) {
        values._id = id
        fetchLoadPlanVehiclesByID(values, (data) => {
          setSelectedNames(data.Result_Output[0].warehouseID);
          setValues(data.Result_Output[0]);
        }, dispatch)
      }
    }
    )();
  }, [dispatch])


  useEffect(() => {
    loadVehicleCategory();
    fetchWarehouseName();
  }, []);

  const fetchWarehouseName = async () => {
    fetchWarehouseByID(values, async (data) => {
      setwarehouseName(data.Result_Output)
    });
  };

  const loadVehicleCategory = async () => {
    loadVehicleCategoryData(values, async (data) => {
      setLoadVehilcles(data.Result_Output)
    });
  };

  // let LoadVehicleLists = LoadVehilcles && LoadVehilcles.length > 0 && LoadVehilcles.map((item, i) => {
  //   if (item.vehicleAllocated === 0) {

  //     const { _id, vehicleCategory, registrationNumber, vehicleType } = item;
  //     return (
  //       <MenuItem key={i} value={_id}>
  //         {registrationNumber}, {vehicleType}
  //       </MenuItem>
  //     );
  //   }


  let LoadVehicleList = LoadVehilcles && LoadVehilcles.length > 0 && LoadVehilcles.map((item, i) => {
    if (id) {
      const { _id,  registrationNumber, vehicleType } = item;
      return (
        <MenuItem key={i} value={_id}>
          {registrationNumber}, {vehicleType}
        </MenuItem>
      );
    }
    else {
      if (item.vehicleAllocated === 0) {
        const { _id, registrationNumber, vehicleType } = item;
        return (
          <MenuItem key={i} value={_id}>
            {registrationNumber}, {vehicleType}
          </MenuItem>
        );
      }
    }

  }, this);


  const clearErrorStates = () => {
    setvehicleIDErr(false);
    setdropWareHouseIDErr(false);
    setvehicleStatusErr(false);
  };

  const addloadVehicleCategory = async () => {
    let mandateFlag = false;
    clearErrorStates();
    values.selectedIDS = selectedNames
    mandateFlag = validateField(values.vehicleID, setvehicleIDErr) || mandateFlag;
    if (values.selectedIDS.length === 0) {
      mandateFlag = validateField(values.selectedIDS, setdropWareHouseIDErr) || mandateFlag;
    }
    mandateFlag = validateField(values.vehicleStatus, setvehicleStatusErr) || mandateFlag;
    if (mandateFlag) {
      return;
    }
    const apiFunction = id === undefined ? addloadVehicleCategoryData : loadPlanVehiclesUpdateData;
    apiFunction(values, (data) => {
      if (data.Result_Status) {
        showResMsg(id === undefined ? genericMessage.added : genericMessage.updated, 1000, data.Result_Status, navigate, routePath);
      } else {
        showResMsg(data.Result_Message, 2000, data.Result_Status);
      }
    }, dispatch);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Height val={30} />
      <Card>
        <MDBox
          mx={2}
          mt={-3}
          mb={1.5}
          py={2}
          px={2}
          variant="gradient"
          bgColor={sidenavColor}
          borderRadius="lg"
          coloredShadow="info"
        >
          <MDTypography variant="h6" color="white">
            {screenName}
          </MDTypography>
        </MDBox>
        <MDBox mt={2} mb={3}>
          <Grid container spacing={2}>
            <Grid item xs={12} spacing={4}>
              <Card sx={{ boxShadow: "none" }}>
                <MDBox pt={2} px={3}>
                  <Grid container columnSpacing={5}>
                    <Grid item xs={12} lg={4}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Vehicle</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "3em" }}
                            label="Vehicle"
                            disabled={id !== undefined ? true : false}
                            value={values.vehicleID}
                            onChange={handleChange("vehicleID")}
                          >
                            {LoadVehicleList}
                          </Select>
                        </FormControl>
                        {vehicleIDErr ? <span style={errMsg}>Vehicle can't be blank</span> : ""}
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">Vehicle Status</InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ minHeight: "3em" }}
                            label="Vehicle Status"
                            disabled
                            value={values.vehicleStatus}
                            onChange={handleChange("vehicleStatus")}
                          >
                            <MenuItem value="New">New</MenuItem>
                            <MenuItem value="Vehicle Assigned">Vehicle Assigned</MenuItem>
                            <MenuItem value="Completed">Completed</MenuItem>
                            <MenuItem value="Locked">Locked</MenuItem>
                          </Select>
                        </FormControl>
                        {vehicleStatusErr ? <span style={errMsg}>Vehicle Status can't be blank</span> : ""}
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={4}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="demo-multiple-checkbox-label">Warehouse Locations</InputLabel>
                          <Select
                            labelId="demo-multiple-checkbox-label"
                            id="demo-multiple-checkbox"
                            multiple
                            style={{ minHeight: "3em" }}
                            value={selectedNames}
                            disabled={values.vehicleStatus !== "New" ? true : false}
                            onChange={(e) => setSelectedNames(e.target.value)}
                            input={<OutlinedInput label="Warehouse Locations" />}
                            renderValue={(selected) => {
                              const selectedNames = wareHouseName.filter((name) => selected.includes(name._id));
                              return selectedNames.map((name) => name.warehouseName).join(', ');
                            }}
                          >
                            {wareHouseName
                              .filter((name) => name._id !== values.warehouseID) // Exclude the logged warehouse
                              .map((name) => (
                                <MenuItem key={name._id} value={name._id}>
                                  <Checkbox checked={selectedNames.indexOf(name._id) > -1} />
                                  <ListItemText primary={name.warehouseName} />
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                        {dropWareHouseIDErr ? <span style={errMsg}>Drop Warehouse can't be blank</span> : ""}
                      </MDBox>
                    </Grid>
                  </Grid>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </Card>
      <Grid
        container
        mt={2}
        columnSpacing={4}
        alignItems="center"
        display="flex"
        justifyContent="center"
      >
        <Grid item xs={12} md={4} spacing={2} lg={1.2}>
          <Link to={"/loadVehicles"}>
            <MDButton
              className="btn-block center-container-btn btn-warning btn-back rightSpace"
              color="warning"
              fullWidth
            >
              Cancel
            </MDButton>
          </Link>
        </Grid>
        <Grid item xs={12} md={4} spacing={2} lg={1.2}>
          <MDButton
            onClick={addloadVehicleCategory}
            variant="gradient"
            color="success"
            fullWidth
          >
            {id === undefined ? "Save" : "Update"}
          </MDButton>
        </Grid>
      </Grid>


    </DashboardLayout>
  );


}
export default AddUser;